import { t } from "@/i18n-js/instance";
import { AudienceEmptyState } from "./AudienceEmptyState";
import { StatItem } from "./StatItem";

const rootLocale = "admin_dashboard.analytics.audience";

export const AudienceTab = () => (
  <div className="space-y-6">
    <div className="grid grid-cols-2 gap-6 sm:grid-cols-4">
      <StatItem title={t([rootLocale, "total_members"])} value={0} />
      <StatItem title={t([rootLocale, "active_members"])} value={0} />
      <StatItem title={t([rootLocale, "inactive_members"])} value={0} />
      <StatItem title={t([rootLocale, "new_members"])} value={0} />
    </div>
    <AudienceEmptyState />
  </div>
);
